import React, { useCallback } from 'react';
import { useDispatch } from 'react-redux';

import { actionCloseModal, actionShowModal, actionSubmitModal, actionUpdateModal } from 'common/redux/modal/actions';
import { ModalAction } from 'common/redux/modal/initialState';

type Props = ModalAction & {
  component: React.ReactNode;
};

export const usePopup = () => {
  const dispatch = useDispatch();

  const show = useCallback(
    (modal: Props) =>
      new Promise<void>((resolve, reject) => {
        dispatch(actionShowModal({ ...modal, onResolve: resolve, onReject: reject }));
      }),
    [dispatch],
  );

  const submit = useCallback(() => {
    dispatch(actionSubmitModal());
  }, [dispatch]);

  const hide = useCallback(() => {
    dispatch(actionCloseModal());
  }, [dispatch]);

  const update = useCallback((data: ModalAction) => dispatch(actionUpdateModal(data)), [dispatch]);

  return { show, submit, hide, update };
};
